import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AppInsightsContext } from "@microsoft/applicationinsights-react-js";
import { appInsightsReactPlugin } from "./components/insights/AppInsights";
import AppRoutes from './components/routing/AppRoutes';
import AppLayout from './components/layout/AppLayout';
import AppAuth from './components/auth/AppAuth';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from './config/msal';
import ErrorBoundary from './components/error/ErrorBoundary';
import { ConfigProvider } from "@bdo/kitchensink";
import { sharedToken, customLightAlgorithm, sharedComponentsToken } from '@bdo/kitchensink/lib/themeConfig';
import { initializeIcons } from '@fluentui/font-icons-mdl2';

import './styles/main.scss';
import './styles/index.css';
import './styles/custom-ant5-overrides.css';
initializeIcons();
// import './styles/fabric-icons.css';
// Complete BDO theme override to fix all color, spacing, and navigation issues

const bdoTheme = {
    token: sharedToken,
    algorithm: [customLightAlgorithm],
    components: sharedComponentsToken
};

export function App() {

    const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href'); 
    const msalInstance = new PublicClientApplication(msalConfig);

    return (
        <AppInsightsContext.Provider value={appInsightsReactPlugin}>
            <BrowserRouter basename={baseUrl}>
                <ErrorBoundary>
                    <MsalProvider instance={msalInstance}>
                        <AppAuth>
                            <ConfigProvider theme={bdoTheme}> 
                                <AppLayout>
                                    <AppRoutes />
                                </AppLayout>
                            </ConfigProvider>
                        </AppAuth>
                    </MsalProvider>
                </ErrorBoundary>
            </BrowserRouter>
        </AppInsightsContext.Provider>
    );
}
